import moment, { Moment } from "moment-timezone";

export function maxBirthDate() {
  return moment().subtract(7, "years");
}

export function minBirthDate() {
  return moment().subtract(80, "years");
}

export function toApiDate(date: Date | Moment): string {
  let momentDate = moment(date);
  return momentDate.utc(true).format();
}

export function getDuration(start: Moment, end: Moment) {
  const d = end.diff(start, "seconds");
  return moment.duration(d, "seconds");
}

export function isValidMoment(date?: Moment | null) {
  return !!date && moment.isMoment(date) && date.isValid();
}

export function getRemainingTime(date: Moment) {
  if (isValidMoment(date)) {
    const now = moment();
    const duration = moment.duration(getDuration(now, date));
    return duration.humanize();
  }
}
export function getTimezone() {
  /**
   * The Intl.DateTimeFormat.prototype.resolvedOptions() method returns a new object with properties reflecting the locale and date and time formatting.
   * The Internationalization API supports getting the user timezone, and is supported in all current browsers.
   * also  moment  have moment-timezone library to handle timeZone.
   * moment-timezone uses the Internationalization API to determine the user's time zone.
   * so i think, we don't need to install moment-timezone library .
   */
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return timeZone;
}

// Comparison that disregards the date part and only looks at time
export function isBeforeTime(timeA: Moment, timeB: Moment): boolean {
  return toReferencedTime(timeA).isBefore(toReferencedTime(timeB));
}

// Comparison that disregards the date part and only looks at time
export function isSameOrAfterTime(timeA: Moment, timeB: Moment): boolean {
  return toReferencedTime(timeA).isSameOrAfter(toReferencedTime(timeB));
}

// This method is to be used when you want to compare two moments on the time portion only 
// disregarding the date reference. It will return a moment with date part set to 2000-01-01 always
export function toReferencedTime(time: Moment): Moment {
  const referenceDate = "2000-01-01"; // This date is an arbitrary value just used to do comparisons on time without date
  const referenceFormat = "YYYY-MM-DD";
  return moment(referenceDate, referenceFormat).utc().set({
    hours: time.hours(),
    minutes: time.minutes(),
    seconds: time.seconds(),
    millisecond: time.milliseconds(),
  });
}
